import React from 'react';
import { useGetTradeDashboardQuery } from '../../../store/api/adminApi';
import PageLoader from '../../../components/PageLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBoxOpen, 
  faNewspaper, 
  faLeaf, 
  faClock, 
  faCheckCircle, 
  faBan, 
  faChessKnight, 
  faCalendarDay, 
  faUsers 
} from '@fortawesome/free-solid-svg-icons';

const AdminTradeDashboard: React.FC = () => {
  const { data, isLoading, error } = useGetTradeDashboardQuery(undefined);

  if (isLoading) {
    return <PageLoader />;
  }

  if (error) {
    return (
      <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
        <div className="alert alert-danger m-5">Error loading dashboard</div>
      </div>
    );
  }

  const dashboardData = data?.data || {};

  const stats = [
    { label: 'Total Packages', value: dashboardData.total_packages || 0, icon: faBoxOpen, color: 'text-primary' },
    { label: 'Total Ads', value: dashboardData.total_ads || 0, icon: faNewspaper, color: 'text-success' },
    { label: 'Free Ads', value: dashboardData.free_ads || 0, icon: faLeaf, color: 'text-info' },
    { label: 'Pending Ads', value: dashboardData.pending_ads || 0, icon: faClock, color: 'text-warning' },
    { label: 'Active Ads', value: dashboardData.active_ads || 0, icon: faCheckCircle, color: 'text-success' },
    { label: 'Rejected Ads', value: dashboardData.rejected_ads || 0, icon: faBan, color: 'text-danger' },
    { label: 'Strategic Ads', value: dashboardData.strategic_ads || 0, icon: faChessKnight, color: 'text-primary' },
    { label: 'Today\'s Ads', value: dashboardData.todays_ads || 0, icon: faCalendarDay, color: 'text-info' },
    { label: 'Total Users', value: dashboardData.total_users || 0, icon: faUsers, color: 'text-dark' },
  ];

  return (
    <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
      <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
          <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
            <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
              <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Trade Dashboard</h1>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-muted">Dashboards</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div id="kt_app_content_container" className="app-container container-fluid">
            <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
              {stats.map((stat, index) => (
                <div key={index} className="col-md-3 mb-md-5 mb-xl-10">
                  <div className="card card-flush h-100 mb-5 mb-xl-10 bg-white hover-elevate-up shadow-sm">
                    <div className="card-body d-flex justify-content-between align-items-center">
                      <div className="d-flex flex-column">
                        <span className="fs-2hx fw-bold text-dark me-2 lh-1 ls-n2">{stat.value}</span>
                        <span className="text-muted pt-1 fw-semibold fs-6">{stat.label}</span>
                      </div>
                      <div className={`d-flex align-items-center justify-content-center w-50px h-50px rounded-3 bg-light`}>
                        <FontAwesomeIcon icon={stat.icon} className={`fs-1 ${stat.color}`} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminTradeDashboard;
